<template>
  <common-template>
    <template v-slot:body>
      <div class="l-wrapper">
        <img class="c-img" src="@/assets/images/logo.png" alt="おトクな不動産情報ミツカル">
        <h2 class="c-title">只今メンテナンス中です。</h2>
        <p class="c-text">
          KEIAIミツカルにアクセスいただきありがとうございます。<br />
          只今メンテナンスを行っております。<br />
          ご不便をおかけいたしますが、再開までしばらくお待ちください。
        </p>
      </div>
    </template>
  </common-template>
</template>

<script>
import IsMobileMixin from '@/plugins/isMobile';
import CommonTemplate from '@/components/templates/CommonTemplate';

export default {
  name: 'Maintenance',
  components: {
    CommonTemplate,
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
    };
  },
  mounted() {
    // Footer表示フラグ更新
    this.$store.commit('setFooterDisplayFlag');
  },
  mixins: [IsMobileMixin],
};
</script>
<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";
.l-wrapper {
  max-width: 900px;
  margin: 100px auto;
  text-align: center;
}
.c-img {
  max-width: 165px;
}
.c-title {
  margin: 53px 0 47px;
  font-size: 18px;
  color: #E83532;
  line-height: 1.2;
}
.c-text {
  font-size: 14px;
  color: #666666;
  line-height: 2;
}

@media screen and (max-width:999px){
  .l-wrapper {
    max-width: 420px;
    margin: 100px auto;
    text-align: center;
  }
}

@media screen and (max-width:767px){
  .l-wrapper {
    max-width: 100%;
    padding: 0 20px;
    margin: 100px auto;
  }
  .c-text {
    text-align: left;
  }
}
</style>
